import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const LEGAL = [
  ["About Us", "/legal/about"],
  ["Contact", "/legal/contact"],
  ["Privacy Policy", "/legal/privacy"],
  ["Terms & Conditions", "/legal/terms"],
  ["Subscription Terms", "/legal/subscription"],
  ["Refund/Cancellation Policy", "/legal/refund"],
  ["Lucky Draw Terms", "/legal/lucky-draw"],
  ["Disclaimer", "/legal/disclaimer"],
  ["Cookie Policy", "/legal/cookies"],
];

export function Footer() {
  return (
    <footer data-testid="main-footer" className="relative border-t border-amber-500/15 bg-[#0A0E20] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <Logo textClass="text-2xl" iconSize={26} />
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
              Your Stars. Your Path. Your Monthly Guidance. Personalized Vedic astrology predictions &
              remedies, delivered every month.
            </p>
          </div>
          <div className="md:col-span-2 grid grid-cols-2 sm:grid-cols-3 gap-3">
            {LEGAL.map(([label, to]) => (
              <Link
                key={to}
                to={to}
                data-testid={`footer-${to.split("/").pop()}`}
                className="text-sm text-slate-400 hover:text-amber-200 transition-colors"
              >
                {label}
              </Link>
            ))}
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-amber-400/90 mb-3">Guidance, not guarantees</p>
            <p className="text-xs text-slate-500 leading-relaxed">
              MyssticChat provides astrology-based guidance for personal reflection and entertainment.
              Predictions are not guaranteed outcomes and are not professional medical, legal or financial advice.
            </p>
          </div>
        </div>
        <div className="hairline mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} MyssticChat.in — All rights reserved.</p>
          <p className="text-xs text-slate-500">Terms &amp; Conditions Apply.</p>
        </div>
      </div>
    </footer>
  );
}
